<template>
  <v-container grid-list-xl fluid>
    <v-layout row fill-height>
      <v-flex xs7 v-show="false">
          <v-card >
              <v-card-title primary-title>
               <p>Use esse espaço para administrar os arquivos de áudio do produto.</p>
               <p>Defina um preview do seu arquivo</p>
              </v-card-title>
          </v-card>
      </v-flex>

      <v-flex xs5 md12>
        <v-card flat hover >
          <v-layout row >
             
            <v-flex xs7>
              <v-card-title primary-title>
                <div>
                  <div v-if="product" class="headline">{{product.name}}</div> 
                   <div v-if="product && product.artist">{{product.artist.name}}</div>                
                  <div v-if="product">{{product.release_date}}</div>
                </div>
              </v-card-title>
            </v-flex>
            <v-flex xs5 v-if="product && product.cover">
              <v-img :src="getImage(product)" height="125px" contain></v-img>
            </v-flex>
          </v-layout>
          <v-divider light></v-divider>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout py-3>
      <v-flex xs6 sm6 md4 v-for="(track, indice) in tracks" :key="track.id">
        <v-card :color="TrackStateColor(indice)" class="white--text">
         
            <v-flex xs12 sm12 md12>
              <v-card-title primary-title>
                <div>
                  <div v-if="track" class="headline">{{track.name}}</div>
                  <div>Faixa: {{indice+1}}</div>
                  <!--div>(2014)</div-->
                </div>
              </v-card-title>
            </v-flex>
            <v-flex xs12  sm12 md12 align-content-center align-center class="text-md-center">
              <input v-show="false" ref="inputUpload" accept=".wav,.mp3,.flac" type="file" @change="onChangeFile"  />
              <v-btn 
              small
                v-show="audio_files[indice].state != 'uploading'" 
                color="white" 
                @click="onSelectFile(indice)">{{TrackStateBtnName(indice)}}</v-btn>

              <v-btn small v-if="audio_files[indice].state == 'readytoupload'" color="green" dark @click="uploadFile(indice)">UPLOAD</v-btn>
              

              <v-progress-circular
              v-if="audio_files[indice].state == 'uploading'"
              :rotate="-90"
              :size="100"
              :width="15"
              :value="audio_files[indice].progress"
              color="purple"
            >
              {{ audio_files[indice].progress }}
            </v-progress-circular>



               <!--input v-if="!cover" color="success" type="file" /-->
              <!--v-img
                    src="https://cdn.vuetifyjs.com/images/cards/foster.jpg"
                    height="125px"
                    contain
              ></v-img-->
            </v-flex>
         
          <v-divider light></v-divider>
          <v-card-actions class="pa-3">
            {{TrackStateMessage(indice)}}
            <!--Rate this album-->
            <v-spacer></v-spacer>
            <!--v-icon large dark>cloud_upload</v-icon-->
            <!--v-icon>star_border</v-icon-->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>


    <v-btn v-show="false" color="red" dark medium fixed bottom right @click="dialog=true">Subida de Arquivos</v-btn>

    <!-- dialog upload -->
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Subida de Arquivos</v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar>
        <v-card-text>ssss</v-card-text>
      </v-card>
    </v-dialog>
    <!-- fim dialog upload-->
  </v-container>
</template>

<script>

import ProductService from "../../../app/Rest/product";

var productService = null;

const state_audioUpload = [ 
    'nofile', //sem arquivo
    'readytoupload', //pronto para subir
    'uploading',
    'uploaded' //ja enviado
  ]
export default {
  components: {},
  data() {
    return {      
      dialog: false,      
      product: {},
      tracks: [],      
      audio_files:[],
      input_selected: null,
    };
  },
  beforeCreate: function() {
    productService = ProductService.build();
    this.editable_product = this.$route.params.id;
    this.$store.dispatch("loading_full");
    productService.getOne(this.editable_product).then(e => {
      if (e.items) {
        this.product = e.items.product;        
        this.tracks = e.items.tracks.map( rr=>{  
              //inidicamos aqui o push
              this.audio_files.push( {                  
                  audio_file:rr.audio_path,
                  state: (rr.audio_path ? 'uploaded':'nofile'),
                  track_id: rr.id,
                  progress:0
                }
              ); return rr;
            }
        );
        this.$store.dispatch("loading_full");
      }
    });
  },
  methods:{
    getImage(product){
	return  process.env.VUE_APP_BASE_URL+product.cover;//getImage
},
    uploadFile(indice){
      this.audio_files[indice].state = 'uploading';
      var parms = {
        track_id: this.audio_files[indice].track_id,
        product_id: this.product.id,
        audio: this.audio_files[indice].file
      }
	var that = this;
      productService.sendAudioFile(parms,{
        onUploadProgress: progressEvent=>{
console.log(progressEvent);
          this.audio_files[indice].progress =  Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          console.log(this.audio_files[indice].progress);
          //that.audio_files[indice].progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      }).then( e=>{
        console.log("indice ", indice," upload complete");
        console.log(this.audio_files[indice]);
        this.audio_files[indice].state = 'uploaded';
      }).catch( e =>{
        alert("Deu algum problema na subida do áudio")
        this.audio_files[indice].state = 'readytoupload';
      })


    },
    onSelectFile(indice){
      console.log(this.$refs.inputUpload);
      console.log(indice)
      this.$refs.inputUpload[indice].click();
      this.input_selected = indice;
    },
    onChangeFile( e ){
       var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;   

      this.audio_files[this.input_selected].color = "success"
      this.audio_files[this.input_selected].file = files[0];
      this.audio_files[this.input_selected].state = "readytoupload";
    },

    //state
    TrackStateMessage(indice){
      let msg = {
        'nofile':'Essa faixa não tem áudio, envie uma.',
        'readytoupload': 'Áudio selecionado, clique no botão "upload"', //pronto para subir
        'uploading': 'Arquivo sendo enviado, aguarde.',
        'uploaded': 'Áudio enviado' //ja enviado
      }

       return msg[ this.audio_files[ indice ].state ];
    },
    TrackStateColor(indice){
      let msg = {
        'nofile':'red',
        'readytoupload': 'orange', //pronto para subir
        'uploading':'orange',
        'uploaded': 'success' //ja enviado
      }

      return msg[ this.audio_files[ indice ].state ];
    },
    TrackStateBtnName(indice){
      let msg = {
        'nofile':'enviar áudio',
        'readytoupload': 'trocar áudio', //pronto para subir
        'uploading':'aguarde',
        'uploaded': 'substituir' //ja enviado
      }

      return msg[ this.audio_files[ indice ].state ];

    }
  }
};
</script>
